import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './navbar.css';
import logo from '../../../images/logo.png';
import { useLocation } from 'react-router-dom';



function Navbar() {

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [navbarStyle, setNavbarStyle] = useState({});
  const [isMobileView, setIsMobileView] = useState(false);
  const location = useLocation();

  // Custom Language Dropdown States
  const [isLangDropdownOpen, setIsLangDropdownOpen] = useState(false);
  const [langSearch, setLangSearch] = useState('');
  const [availableLanguages, setAvailableLanguages] = useState([]);
  const [currentLang, setCurrentLang] = useState('Select Language');

  
  const checkMobileView = () => {
    setIsMobileView(window.innerWidth <= 768); // Adjust the breakpoint as needed
  };

  useEffect(() => {
    checkMobileView();
    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const select = document.querySelector('.goog-te-combo');
      if (select && select.options.length > 0) {
        const langs = Array.from(select.options).map(opt => ({
          code: opt.value,
          name: opt.text
        })).filter(opt => opt.code !== ''); // filter out the default
        setAvailableLanguages(langs);
        clearInterval(interval);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleLangDropdown = (e) => {
    e.stopPropagation();
    setIsLangDropdownOpen(!isLangDropdownOpen);
  };

  const handleLanguageSelect = (code, name) => {
    setCurrentLang(name);
    const select = document.querySelector('.goog-te-combo');
    if (select) {
      select.value = code;
      select.dispatchEvent(new Event('change'));
    }
    setIsLangDropdownOpen(false);
    setLangSearch('');
  };

  const filteredLanguages = availableLanguages.filter(lang => 
    lang.name.toLowerCase().includes(langSearch.toLowerCase())
  );


  // const toggleDropdown = (event) => {
  //   event.stopPropagation(); // Prevent event propagation to parent elements
  //   setIsDropdownOpen((prevState) => !prevState); // Toggle the dropdown state
  // };

  const handleClickOutside = (event) => {
    // Close dropdown if click is outside the dropdown area
    if (!event.target.closest('.dropdown') && !event.target.closest('.hamburger')) {
      setIsDropdownOpen(false);
    }
    if (!event.target.closest('.custom-lang-dropdown')) {
      setIsLangDropdownOpen(false);
    }
  };

  const handleScroll = () => {
    const windowWidth = window.innerWidth; // Get the current window width
  
    if (window.scrollY > 150) {
      if (windowWidth >= 1024 && windowWidth <= 1539) {
        // Apply padding only if screen width is between 1024px and 1539px
        setNavbarStyle({
          padding: '5px 0px',
          backgroundColor: 'white',
        });
      } else {
        // Apply different padding for other screen sizes if necessary
        setNavbarStyle({
          padding: '5px 20px', // Default padding for other screen sizes
          backgroundColor: 'white',
        });
      }
    } else {
      setNavbarStyle({
        backgroundColor: 'transparent',
        padding: windowWidth >= 1024 && windowWidth <= 1539 ? '5px 0px' : '5px 20px', // Adjust for screen width
      });
    }
  };
  

  const handleMouseEnter = () => {
    if (!isMobileView) {
      setIsDropdownOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobileView) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    document.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div>
      {/* Main Navbar */}
      <div className="main-navbar" id="navbar" style={navbarStyle}>
        <div className="logo notranslate">
        <NavLink
                to="/"
                className={({ isActive }) => (isActive ? 'main-active' : '')}
                onClick={() => {
                  toggleMobileMenu();
                  window.scrollTo(0, 0);
                }}
              >
                <img src={logo} alt="Logo" />
              </NavLink>
          
        </div>

        <div className={`nav-links ${isMobileMenuOpen ? 'open' : ''}`}>
          <button className="close-btn" onClick={toggleMobileMenu}>
            &times;
          </button>
          <ul>
            <li>
              <NavLink
                to="/"
                className={({ isActive }) => (isActive ? 'main-active' : '')}
                onClick={() => {
                  toggleMobileMenu();
                  window.scrollTo(0, 0);
                }}
              >
                Home
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/consultancy"
                className={({ isActive }) => (isActive ? 'main-active' : '') }
                onClick={() => {
                  toggleMobileMenu();
                  window.scrollTo(0, 0);
                }}
              >
                Consultancy
              </NavLink>
            </li>


            <li>
              <NavLink
                to="/product"
                className={
                  location.pathname.startsWith('/product') ? 'main-active' : ''
                }
                onClick={() => {
                  toggleMobileMenu();
                  window.scrollTo(0, 0);
                }}
              >
                Product
              </NavLink>
            </li>
            <li
  className={`dropdown ${isDropdownOpen ? 'open' : ''}`}
  onMouseEnter={handleMouseEnter} // Open dropdown on hover (desktop)
  onMouseLeave={handleMouseLeave} // Close dropdown on hover out (desktop)
>
  {/* Main Institute Link */}
  <NavLink
    to="/institute"
    className={({ isActive }) => (isActive ? 'main-active' : '')}
    onClick={(e) => {
      if (isMobileView) {
        // Prevent dropdown toggle when clicking the Institute link in mobile view
        toggleMobileMenu();
        window.scrollTo(0, 0);
      }
    }}
  >
    Institute
  </NavLink>

  {/* Arrow Button */}
  {isMobileView ? (
    <button
      className="arrow"
      onClick={(e) => {
        e.stopPropagation(); // Prevent propagation to NavLink
        setIsDropdownOpen((prevState) => !prevState); // Toggle the dropdown
      }}
    >
      &#9662;
    </button>
  ) : (
    <span className="arrow">&#9662;</span>
  )}

  {/* Dropdown Content */}
  {isDropdownOpen && (
    <div className="dropdown-content">
      <NavLink
        to="/workshop"
        className={
          location.pathname.startsWith('/workshop') ? 'main-active' : ''
        }
        onClick={() => {
          setIsDropdownOpen(false); // Close dropdown after navigation
          toggleMobileMenu();
          window.scrollTo(0, 0);
        }}
      >
        <p>Workshop</p>
      </NavLink>
      <NavLink
        to="/video"
        className={({ isActive }) => (isActive ? 'main-active' : '')}
        onClick={() => {
          setIsDropdownOpen(false); // Close dropdown after navigation
          toggleMobileMenu();
          window.scrollTo(0, 0);
        }}
      >
        <p>Videos</p>
      </NavLink>
      <NavLink
        to="/course"
        className={({ isActive }) => (isActive ? 'main-active' : '')}
        onClick={() => {
          setIsDropdownOpen(false); // Close dropdown after navigation
          toggleMobileMenu();
          window.scrollTo(0, 0);
        }}
      >
        <p>Course</p>
      </NavLink>
    </div>
  )}
</li>

            <li>
              <NavLink
                to="/workshop"
                className={
                  location.pathname.startsWith('/workshop') ? 'main-active' : ''
                }
                onClick={() => {
                  toggleMobileMenu();
                  window.scrollTo(0, 0);
                }}
              >
                Workshop
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/video"
                className={({ isActive }) => (isActive ? 'main-active' : '')}
                onClick={() => {
                  toggleMobileMenu();
                  window.scrollTo(0, 0);
                }}
              >
                Videos
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                className={({ isActive }) => (isActive ? 'main-active' : '')}
                onClick={() => {
                  toggleMobileMenu();
                  window.scrollTo(0, 0);
                }}
              >
                Contact Us
              </NavLink>
            </li>

              <li>
              <NavLink
                to="/healthchecker"
                className={({ isActive }) => (isActive ? 'main-active' : '')}
                onClick={() => {
                  toggleMobileMenu();
                  window.scrollTo(0, 0);
                }}
              >
                Health Checker
              </NavLink>
            </li>
            <li className='animate'>
              <div className="how">
                <NavLink
                  to="/contact"
                  onClick={() => {
                    window.scrollTo(0, 0);
                  }}
                >
                  <button type="button" className="btn">Book a Free Discovery Call</button>
                </NavLink>
              </div>
            </li>
            <li className="custom-lang-dropdown notranslate" onClick={toggleLangDropdown}>
              <div className="selected-lang">
                <i className="fas fa-globe" style={{marginRight: '8px'}}></i>
                {currentLang === 'Select Language' ? 'Language' : currentLang} 
                <span className="lang-arrow">▼</span>
              </div>
              
              {isLangDropdownOpen && (
                <div className="lang-dropdown-menu">
                  <div className="lang-search-box">
                    <i className="fas fa-search"></i>
                    <input 
                      type="text" 
                      placeholder="Search language..." 
                      value={langSearch}
                      onChange={(e) => setLangSearch(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                  <ul className="lang-list">
                    {filteredLanguages.length > 0 ? (
                      filteredLanguages.map(lang => (
                        <li 
                          key={lang.code} 
                          onClick={() => handleLanguageSelect(lang.code, lang.name)}
                          className="lang-item"
                        >
                          {lang.name}
                        </li>
                      ))
                    ) : (
                      <li className="lang-item empty">No results found</li>
                    )}
                  </ul>
                </div>
              )}
            </li> 
          </ul>
        </div>

        <div class="whatsapp_float">

          <a href="https://wa.me/+917892307418" target="_blank" rel="noreferrer">
            <img src="/images/whatsapp_logo.png" height="80px" width="80px" alt='' class="whatsapp_float_btn" /></a>
        </div>

        <div className="hamburger" onClick={toggleMobileMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>
    </div>



  );
}

export default Navbar;
